// extracted by mini-css-extract-plugin
module.exports = {"subRatingsWrap":"styles_subRatingsWrap__60Ig5","subRating":"styles_subRating__bJvMz","subScore":"styles_subScore__m7N51","bar":"styles_bar__CqvuR"};